export class GenericDictionary { [key: string]: GenericDictionary }

export class Dictionary<T,V> extends Map<T, V> {}